export enum PrintStatus {
	NotPrinted = 'NotPrinted',
	Printed = 'Printed',
	PartiallyPrinted = 'PartiallyPrinted',
}
